import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminOrdersTranslation } from "../../translations";

// LoadingSpinner Component
export const LoadingSpinner = () => {
    const { language } = useLanguage();
    const { t } = useAdminOrdersTranslation(language);

    return (
        <div className="admin-loading">
            <div className="loader"></div>
            <p>{t('loading')}</p>
        </div>
    );
};

export default LoadingSpinner;